export default "__VITE_ASSET__ClZa7UEX__"